import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'
import styles from './styles'

const LiveStreamErrorDialog = ({ channel }) => (
  <div className="LiveStreamErrorDialog">
    <Dialog
      title="Oops. Something went wrong!"
      subtitle="It looks like there is a problem with the Live stream. Please try reloading again."
    />
    <div className="button-container">
      <ButtonRounded
        fullWidth
        text="Reload"
        href={`/live/${channel}`}
      />
    </div>
    <style jsx>{styles}</style>
  </div>
)

LiveStreamErrorDialog.propTypes = {
  channel: PropTypes.string.isRequired,
}

export default LiveStreamErrorDialog
